import { Component, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ModalComponent } from "../../shared/modeldialog/index";
import { SecurityService } from '../../Security/security.service';
import { BookingService } from "../../booking/service/booking.service";
import { LoginService } from "../../login/service/login.service";
import { ServicePaymentService } from "../../servicepayment/service/servicepayment.service";
import { UserData, PaymentDetails, PaytabsPaymentDetails, PaymentHistory, ServicePaykeyvaluepair, PaymentDetailsDataContainer, FileSearch } from "../../model/index";
import { AdvancePaymentService } from "../../advancepayment/service/advancepayment.service";
import { OtpModel } from "../../Model/ServicePayment/OtpModel";
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';

declare let jspdf: any;
declare let html2canvas: any;
declare var require: any;

@Component({
    selector: 'MentisSoft-SearchServicePayment',
    template: require('../Template/SearchServicePayment.template.html'),
    providers: [ServicePaymentService, AdvancePaymentService, LoginService]
})

export class SearchServicePaymentComponent implements AfterViewInit {
    @ViewChild("viewModelPopup") Printpopup: ModalComponent;

    year = new Date();
    appDate: Object = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
    appDate1: Object = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
    activebutton: number = this.year.getDay();
    myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        firstDayOfWeek: 'su',
        satHighlight: false,
        sunHighlight: false,
    };

    loading = false;
    redirectString: string;
    Querynumber: string;
    outQueryNumber: string = "";
    paymentDetails: PaymentDetails[] = [];
    temp: number = 0;
    totalGrossAmount: number = 0;
    totalGrossAmountString: string = "";
    totalAdjustedAmount: number = 0;
    totalPatientPartAmount: number = 0;
    dataSource: PaymentDetails[] = [];
    paymentServicesForPaytabs: PaymentDetails[] = [];
    paytabsPaymentDetails: PaytabsPaymentDetails = new PaytabsPaymentDetails();
    paymentDetailsbefore: PaymentDetails[] = [];
    paymentDetailsafter: PaymentDetails[] = [];
    isValid: boolean = false;
    tempString: string;
    CurrencyValue: string;
    EnableAmountAdjustColumn: boolean = false;
    adjustedAmountCalc: number = 0;
    IsAmountAdjusted: boolean = false;
    items: { [index: string]: number } = {};
    dictValues: ServicePaykeyvaluepair[] = [];
    enableNewColumn: boolean = false;
    enableConfirmButton: boolean = false;
    copayAmountTotalRchd: boolean = false;
    totalAmountToBePaid: number = 0;
    enablePaymentButton: number = 0;
    ConfirmButtonStatus: number = 0;
    countConfirm: number = 0;
    Isadjust: number = 0;
    amountAdjustmentCalculated: boolean = false;
    totalAmountToBePaidSting: string = "";
    totalPatientPartAmountString: string = "";

    fileSearch: FileSearch = new FileSearch();
    fileSearchRes: FileSearch[] = [];
    appointmentCivilId: string = "";
    appointmentPatientId: string = "";
    SelecterrMsg: string = "";
    IsselectPatientSearch: boolean = false;
    CvilIdNoRed: boolean = false;
    enableProceed: boolean = false;
    IsPatientcountone: boolean = true;
    selectedPatientId: string = "";
    IsMobileText: boolean = false;
    SpatientId: string = "";
    CPRNOlength: string = "";
    GuestNewPatientReq: string = "";
    PortalType: string = "";

    TimeCounter: string = "";
    IsOTPSent: boolean = false;
    otpModel: OtpModel = new OtpModel();
    VerifyOtperrMsg: string = "";
    IsVerifyOtpClicked: boolean = false;
    IsOtpVerifiedSucess: boolean = false;
    OtpNumber: string = "";
    IsSearchBtnClicked: boolean = false;
    IsDetailsDisplay: boolean = false;
    HiddenMobileNumber: string = "";
    AppNumber: string = "";
    transactionNo: string = "";
    PayedPayAmount: string = "";
    IsTransaction: boolean = true;
    PaymentErroMsg: string = "";
    printpatientId: string = "";
    ReceiptNo: string = "";
    finalTotalAmount: number = 0;
    Cancelurl: string = "";
    QueryResult: string = "";
    IsServicesEnable: boolean = false;
    enablePayProceedButton: boolean = false;
    guestBooking: boolean = false;
    ToDate: string = new Date().toLocaleDateString(); 
    FromDate: string = new Date().toLocaleDateString();
    PatientName: string = "";
    BackMenu: string;
    DateErrorerrMsg: string = "";
    IsDateError: boolean = false;
    KioskORPortal: string = localStorage.getItem("KioskORPortal");
	tapQuerynumber:string;

    ngOnInit() {
    }
    ngAfterViewInit() {
        $('#overlay').hide();
        this._titleService.setTitle("Service Payment");
        if (this.Querynumber != "" && this.Querynumber != undefined && this.QueryResult == "CAPTURED") {
            this.paytabsPaymentDetails.RedirectResult = "CAPTURED";
            this.LoadingAfterPayment(this.Querynumber);
        }
        if (this.Querynumber != "" && this.Querynumber != undefined) {
            if (this.QueryResult != "CAPTURED" && this.QueryResult != "" && this.QueryResult != undefined) {
                this.paytabsPaymentDetails.RedirectResult = this.QueryResult;
                this.LoadingAfterPayment(this.QueryResult);
            }
            else {
                if (this.QueryResult == "" || this.QueryResult == undefined) {
                    this.paytabsPaymentDetails.RedirectResult = this.QueryResult;
                    this.LoadingAfterPayment(this.Querynumber);
                }
            }
        }
        if (this.Querynumber == undefined && this.Cancelurl != "" && this.Cancelurl != "" && this.Cancelurl == "__hc-action-cancel") {
            this.paytabsPaymentDetails.RedirectResult = "CANCEL";
            this.LoadingAfterPayment("CANCEL");
        }
        if (this.Querynumber == "" && this.QueryResult == "") {
            this.paytabsPaymentDetails.RedirectResult = "DENIED+BY+RISK";
            this.LoadingAfterPayment("DENIED+BY+RISK");
        }
		if (this.tapQuerynumber != "" && this.tapQuerynumber != undefined) {
            this.paytabsPaymentDetails.RedirectResult = "TAPPAY";
            //if (this.generalBooking.CaptureData == "CAPTURED")
            //    this.Alertpayment.open();
            this.LoadingAfterPayment("TAPPAY");
        } 
        let queryStringCount: number = this.router.url.indexOf("?");
        if (queryStringCount == 1) {
            this.LoadPaymentReports();
        }
        
        if (localStorage.getItem("BookingType") == "SLOT") {
            this.enableConfirmButton = true;
        }
        else {
            this.enableConfirmButton = false;
        }
        this.PortalType = localStorage.getItem("PortalType");
        if (this.PortalType == "KIOSK" || this.KioskORPortal == "KIOSK")
            this.BackMenu = "Back To Menu";
        else
            this.BackMenu = "Back To Login";
    }

    constructor(@Inject(SecurityService) private _SecurityService: SecurityService, private _titleService: Title, private _bookingService: BookingService, private _LoginService: LoginService,
        private _paymentService: ServicePaymentService, private _router: Router, private _advancePaymentService: AdvancePaymentService, private router: Router) {
        this.Cancelurl = router.parseUrl(router.url).fragment;
		this.tapQuerynumber = router.parseUrl(router.url).queryParams["tap_id"];
        this.paytabsPaymentDetails.Tap_id  = this.tapQuerynumber;
        this.Querynumber = router.parseUrl(router.url).queryParams["Id"];
        this.paytabsPaymentDetails.AppReqPatientId = this.Querynumber;

        this.AppNumber = router.parseUrl(router.url).queryParams["AppNumber"];
        this.paytabsPaymentDetails.AppointmentRquestNo = this.AppNumber;

        this.QueryResult = router.parseUrl(router.url).queryParams["result"];
        if (this.Querynumber == "" || this.Querynumber == undefined) {
            this.Querynumber = this.router.parseUrl(this.router.url).queryParams["result"];
        }

        this.outQueryNumber = this.Querynumber
        this.IsOTPSent = false;

        this.IsSearchBtnClicked = false;
    }

    LoadPaymentReports() {
        this.paymentDetails = [];
        this.ToDate = new Date().toLocaleDateString();
        this.FromDate = new Date().toLocaleDateString();
        this.IsServicesEnable = true;
        this.loading = true;
        var userData: UserData = new UserData(this.SpatientId, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this._paymentService.PaymentDetailsOut(this.SpatientId, userData)
            .subscribe(
                p => {
                        var a = [];
                        this._SecurityService.errorMessage = "";
                        if (p.length == 0) {
                            this.ConfirmButtonStatus = 0;
                        }
                            this.dataSource = p;
                        for (var i = 0; i < p.length; i++) {
                            p[i].AmountString = p[i].Amount.toFixed(2);
                            p[i].PriceString = p[i].Price.toFixed(2);
                            if (p[i].Amount.toString().indexOf('.') <= 0) {
                                p[i].AmountString = p[i].Amount + ".00";
                            }
                            if (p[i].Price.toString().indexOf('.') <= 0) {
                                p[i].PriceString = p[i].Price + ".00";
                            }
                            if (new Date(p[i].RequestDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) == new Date().toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }))
                                this.paymentDetails.push(p[i]);
                            if (localStorage.getItem("BookingType") == "SLOT") {
                                if (a.indexOf(p[i].SponsorCode) <= -1) {
                                    a.push(p[i].SponsorCode);
                                    let kv: ServicePaykeyvaluepair = new ServicePaykeyvaluepair();
                                    kv.key = p[i].SponsorCode;
                                    kv.value = p[i].Co_payAmount;
                                    this.dictValues.push(kv);
                                }
                            }
                        }
                    
                    this.loading = false;

                });
    }

    checkForSelectedCheckboxes(paymentDetails) {
        for (var i = 0; i < paymentDetails.length; i++) {
            if (paymentDetails[i].ServiceChecked == true) {
                this.totalGrossAmount = this.totalGrossAmount + this.paymentDetails[i].Amount;
                this.totalGrossAmountString = this.totalGrossAmount.toFixed(2);
                this.totalPatientPartAmount = this.totalPatientPartAmount + this.paymentDetails[i].Price;
                this.totalPatientPartAmountString = this.totalPatientPartAmount.toFixed(2);
                this.temp = this.totalGrossAmount;
                this.tempString = this.temp.toString();
                if (this.temp.toString().indexOf('.') <= 0) {
                    this.tempString = this.temp + ".00";
                }
                localStorage.setItem("TotalAmount", this.temp.toString());
            }
        }
    }

    AlternateNoChange(event) {
        this.IsselectPatientSearch = false;
        this.CPRNOlength = localStorage.getItem("CPRNOlength");
        if (event.target.value.length > Number(this.CPRNOlength) || event.target.value.length != Number(this.CPRNOlength)) {
            this.CvilIdNoRed = true;
        }
        else {
            this.CvilIdNoRed = false;
        }
    }

    Search() {
        this.IsDateError = false;
        this.DateErrorerrMsg = "";
        this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
        this.appDate1 = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
        this.ToDate = new Date().toLocaleDateString();
        this.FromDate = new Date().toLocaleDateString();
        this.paymentDetails = [];
        this.loading = true;
        this.IsSearchBtnClicked = false;
        this.IsOtpVerifiedSucess = false;
        this.IsOTPSent = false;
        this.fileSearch.PatientId = "";
        this.fileSearch.CPRNO = "";
        this.fileSearchRes = [];
        this.fileSearch = new FileSearch();
        this.selectedPatientId = "";
        this.SpatientId = "";
        this.CPRNOlength = localStorage.getItem("CPRNOlength");
        if ((this.appointmentPatientId == "" || this.appointmentPatientId == undefined || this.appointmentPatientId == null)
            && (this.appointmentCivilId == "" || this.appointmentCivilId == undefined || this.appointmentCivilId == null)) {
            this.SelecterrMsg = "Please enter the required mandatory(*) filed.";
            this.IsselectPatientSearch = true;
            this.CvilIdNoRed = false;
            this.IsMobileText = false;
            this.enableProceed = false;
            this.loading = false;
        }
        else if ((this.appointmentPatientId == "" || this.appointmentPatientId == undefined || this.appointmentPatientId == null)
            && (this.appointmentCivilId != "" || this.appointmentCivilId != undefined || this.appointmentCivilId != null) && this.appointmentCivilId.length < Number(this.CPRNOlength)) {
            this.SelecterrMsg = "";
            this.IsselectPatientSearch = false;
            if (this.appointmentCivilId.length == Number(this.CPRNOlength))
                this.CvilIdNoRed = false;
            else
                this.CvilIdNoRed = true;

            this.IsMobileText = false;
            this.enableProceed = false;
            this.loading = false;
        }
        else {
            this.CvilIdNoRed = false;
            this.SelecterrMsg = "";
            this.fileSearch.PatientId = this.appointmentPatientId;

            this.fileSearch.CPRNO = this.appointmentCivilId;

            this._LoginService.getAppointmentPatientSearch(this.fileSearch)
                .subscribe(
                    p => {
                        if (p != null) {
                            if (!p.IsValidPatient) {
                                if (localStorage.getItem("HospitalName").toUpperCase() == "HADI") {
                                    this.SelecterrMsg = "Search Patient file not exist, please contact 1828282 for more info. ";
                                }
                                else {
                                    if (this.GuestNewPatientReq == "TRUE") {
                                        this.SelecterrMsg = "Search Patient is not valid, please proceed as guest ";
                                    }
                                    else {
                                        this.SelecterrMsg = "Search Patient is not valid. ";
                                    }
                                }
                                this.IsselectPatientSearch = true;
                                this.IsMobileText = false;
                                this.enableProceed = false;
                            }
                            else {
                                this.CurrencyValue = p.CurrencyValue;
                                if (p.fileSearch.length > 0) {
                                    this.IsOtpVerifiedSucess = false;
                                    this.IsSearchBtnClicked = true;
                                    this.IsDetailsDisplay = true;
                                    this.fileSearchRes = p.fileSearch;
                                    this.selectedPatientId = p.fileSearch[0].PatientId;
                                    this.SpatientId = p.fileSearch[0].PatientId;
                                    this.otpModel.MOBILENO = p.fileSearch[0].MobileNumber;
                                    this.otpModel.PATIENTID = p.fileSearch[0].PatientId;
                                    if (p.fileSearch.length == 1) {
                                        this.IsPatientcountone = true;
                                        this.IsMobileText = true;
                                        this.enableProceed = true;
                                    }
                                    else {
                                        this.IsPatientcountone = false;
                                        this.IsMobileText = true;
                                        if (this.SpatientId != "" && this.SpatientId != null && this.SpatientId != undefined)
                                            this.enableProceed = true;
                                        else
                                            this.enableProceed = false;
                                    }
                                    this.SelecterrMsg = "";
                                    this.IsselectPatientSearch = false;
                                }
                            }

                        }
                        this.loading = false;
                    },
                    err => {
                        this.loading = false;
                        console.log("Error while validating...");
                    }

                );
        }
    }

    radioClick(patientId, DummyMobileNumber, MobileNumber, OBGYDept, Sex, Age) {
        this.IsOtpVerifiedSucess = false;
        this.IsOTPSent = false;
        this.VerifyOtperrMsg = "";
        this.IsSearchBtnClicked = true;
        this.SpatientId = patientId;
        this.selectedPatientId = patientId;
        this.HiddenMobileNumber = DummyMobileNumber;
        this.HiddenMobileNumber = DummyMobileNumber;
        this.otpModel.MOBILENO = MobileNumber;
        this.otpModel.PATIENTID = this.SpatientId;
        
        this.enableProceed = true;
    }
    CalculateTotalForSelectedServices(paymentData) {
        if (paymentData.ServiceChecked == true) {
            this.finalTotalAmount = this.finalTotalAmount+paymentData.Amount;
        }
        else {
            this.finalTotalAmount = this.finalTotalAmount - paymentData.AmountString;
        }
        if (this.finalTotalAmount > 0)
            this.enablePayProceedButton = true;
        else
            this.enablePayProceedButton = false;
        this.totalPatientPartAmountString = this.finalTotalAmount.toFixed(2);
        this.totalAmountToBePaidSting = this.finalTotalAmount.toFixed(2);
        this.totalGrossAmountString = this.finalTotalAmount.toFixed(2);
        localStorage.setItem("TotalAmount", this.totalAmountToBePaidSting.toString());
    }
    CalculateTotalForSelectedServicesold(paymentData) {

        if (paymentData.ServiceChecked == true) {
            this.countConfirm = this.countConfirm + 1;
        }
        else {
            if (this.countConfirm == 0)
                this.countConfirm = 0
            else
                this.countConfirm = this.countConfirm - 1;
        }
        if (this.countConfirm > 0)
            this.ConfirmButtonStatus = 1;
        else
            this.ConfirmButtonStatus = 0;
        this.enablePaymentButton = 0;
        if (paymentData.ServiceChecked == false) {

            if (paymentData.AdjustedAmount != undefined) {
                this.totalAmountToBePaid = this.totalAmountToBePaid - paymentData.AdjustedAmount;
                this.totalAmountToBePaidSting = this.totalAmountToBePaid.toFixed(2);
                this.Isadjust = 1;
            }

            this.totalPatientPartAmount = this.totalPatientPartAmount - paymentData.Price;
            this.totalPatientPartAmountString = this.totalPatientPartAmount.toFixed(2);
            this.totalGrossAmount = this.totalGrossAmount - paymentData.Amount;
            this.totalGrossAmountString = this.totalGrossAmount.toFixed(2);
            this.tempString = this.temp.toString();
            if (this.temp.toString().indexOf('.') <= 0) {
                this.tempString = this.temp + ".00";
            }
        }
        else {
            if (paymentData.AdjustedAmount != undefined) {
                this.totalAmountToBePaid = this.totalAmountToBePaid + paymentData.AdjustedAmount;
                this.totalAmountToBePaidSting = this.totalAmountToBePaid.toFixed(2);
            }
            this.totalPatientPartAmount = this.totalPatientPartAmount + paymentData.Price;
            this.totalPatientPartAmountString = this.totalPatientPartAmount.toFixed(2);
            this.totalGrossAmount = this.totalGrossAmount + paymentData.Amount;
            this.totalGrossAmountString = this.totalGrossAmount.toFixed(2);
            this.tempString = this.temp.toString();
            if (this.temp.toString().indexOf('.') <= 0) {
                this.tempString = this.temp + ".00";
            }
        }

        localStorage.setItem("TotalAmount", this.temp.toString());
        this.enableNewColumn = false;

    }

    LoadPaymentGrid() {
        this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
        this.appDate1 = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
        this.ToDate = new Date().toLocaleDateString();
        this.FromDate = new Date().toLocaleDateString();
        this.paymentDetails = [];
        this.IsDateError = false;
        this.DateErrorerrMsg = "";

        this.LoadPaymentReports();

    }

    ServicePaymentPaytabs() {
        this.loading = true;
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        for (var i = 0; i < this.paymentDetails.length; i++) {
            if (this.paymentDetails[i].ServiceChecked == true) {
                if (localStorage.getItem("HospitalName").toUpperCase() == "HADI") {
                    this.paymentDetails[i].LocationCode = "100";
                }
                this.paymentDetails[i].IsPortalKiosk = this.KioskORPortal;
                this.paymentServicesForPaytabs.push(this.paymentDetails[i]);
                this.paymentDetailsbefore.push(this.paymentDetails[i]);
            }
        }
        this.paytabsPaymentDetails = this.PaytabsPaymentDetailsData(this.paymentServicesForPaytabs);
        this.paytabsPaymentDetails.ScreenName = "SearchServicePayment";
        if (this.totalAmountToBePaidSting != "" && this.totalAmountToBePaidSting != undefined) {
            this.paytabsPaymentDetails.Amount = this.totalAmountToBePaidSting;
        }
        this.paytabsPaymentDetails.AppReqPatientId = this.SpatientId;
        localStorage.setItem("PaytabsPaymentDetails", JSON.stringify(this.paymentDetailsbefore));
        localStorage.setItem("KioskORPortal", this.KioskORPortal);
        this._paymentService.ProceedToPayTabsOut(this.paytabsPaymentDetails, userData)
            .subscribe(
                p => {
                    this.redirectString = p.PaymentRedirectSiteUrl;
                    if (p.PaymentRedirectSiteUrl != null && p != null) {
                        if (window.location.href.indexOf('paytabs') <= 0) {
                            window.location.replace(p.PaymentRedirectSiteUrl);
                        }
                    }
                });
    }

    LoadingAfterPayment(Querynumber: string) {
        this.loading = true;
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        var data = localStorage.getItem("TotalAmount");
        this.paymentDetailsafter = JSON.parse(localStorage.getItem("PaytabsPaymentDetails"));

        for (var i = 0; i < this.paymentDetailsafter.length; i++) {
            this.paymentDetailsafter[i].TotalAmount = data;
            this.paymentDetailsafter[i].appNumber = this.AppNumber;
            this.paymentDetailsafter[i].CaptureData = this.paytabsPaymentDetails.RedirectResult;
			this.paymentDetailsafter[i].Tap_id = this.paytabsPaymentDetails.Tap_id;
        }

        this._paymentService.AfterPaymentConfirmationOut(Querynumber, userData, data, this.paymentDetailsafter)  
            .subscribe(
                s => {
                        if (s.isValid) {
                            this.isValid = true;
                            this.transactionNo = s.transaction_id;
                            this.PayedPayAmount = s.PayAmount;
                            this.printpatientId = s.PatientId;
                            this.ReceiptNo = s.ReceiptNo;
                            this.PatientName = s.PatientName;
                            this.guestBooking = true;
                            this.loading = false;

                        }
                        else if (!s.isValid) {
                            this.isValid = false;
                            this.transactionNo = s.transaction_id;
                            if (this.transactionNo == undefined || this.transactionNo == "" || this.transactionNo == "")
                                this.IsTransaction = false;
                            else
                                this.IsTransaction = true;
                            if (s.result == "CAPTURED")
                                this.PaymentErroMsg = "Payment success, we are unable to print the receipt no.  Please contact hospital.";
                            else if (s.result == "NOT+CAPTURED" || s.result == "NOTCAPTURE")
                                this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                            else if (s.result == "HOST+TIMEOUT")
                                this.PaymentErroMsg = "Time out. We are unable to process your payment. Please try again";
                            else if (s.result == "CANCELLED")
                                this.PaymentErroMsg = "Your process has been cancelled. We are unable to process your payment. Please try again";
                            else if (s.result == "DENIED+BY+RISK")
                                this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                            else
                                this.PaymentErroMsg = "We are unable to process your appointment.Please try again";
                            this.guestBooking = true;
                            this.loading = false;

                        }
                        else {
                            this.guestBooking = false;
                            this.loading = false;

                        }
                },
            err => {
                       this.loading = false;
                    console.log("Error while getting data...");
                });
    }
   

    PaytabsPaymentDetailsData(paymentServicesForPaytabs) {
        let data: any;
        this.paytabsPaymentDetails.UnitPrice = "";
        this.paytabsPaymentDetails.Quantity = "";
        this.paytabsPaymentDetails.ProductsPerTitle = "";
        this.paytabsPaymentDetails.Title = "Service Payment";
        for (var i = 0; i < paymentServicesForPaytabs.length; i++) {
            this.paytabsPaymentDetails.ProductsPerTitle = this.paytabsPaymentDetails.ProductsPerTitle + paymentServicesForPaytabs[i].ServiceName + " " + "||" + " ";
            this.paytabsPaymentDetails.Quantity = this.paytabsPaymentDetails.Quantity + paymentServicesForPaytabs[i].Quantity + " " + "||" + " ";

            if (this.paymentServicesForPaytabs[i].Amount.toString().indexOf(".") <= 0) {
                data = this.paymentServicesForPaytabs[i].Price + ".00"
            }

            else {
                data = this.paymentServicesForPaytabs[i].Price;
            }
            this.paytabsPaymentDetails.UnitPrice = this.paytabsPaymentDetails.UnitPrice + data + " " + "||" + " ";
            this.paytabsPaymentDetails.Amount = this.temp.toString();
        }
        return this.paytabsPaymentDetails;
    }

    ClosePopup() {
        this.LoadPaymentReports();
    }

  

    EnableAmountAdjust() {
        this.totalPatientPartAmountString = "";
        this.totalAmountToBePaidSting = "";
        this.totalGrossAmountString = "";
        this.totalAmountToBePaid = 0;
        this.totalAmountToBePaidSting = "";

        var ServiceCheckedTotalAmount = 0;
        for (var i = 0; i < this.dictValues.length; i++) {
            ServiceCheckedTotalAmount = 0;
            this.copayAmountTotalRchd = false;
            this.totalAdjustedAmount = 0;
            for (var j = 0; j < this.paymentDetails.length; j++) {
                if (this.paymentDetails[j].ServiceChecked && this.dictValues[i].key == this.paymentDetails[j].SponsorCode) { //checks for same SponsorCode
                    ServiceCheckedTotalAmount = ServiceCheckedTotalAmount + this.paymentDetails[j].Price; //Adds the patient part amount of each service.
                }
            }

            if (ServiceCheckedTotalAmount > this.dictValues[i].value) { // Checks if the copay amount is greater than the total amount of services checked.
                this.adjustedAmountCalculation(this.dictValues[i]); // if greater adjusted amount needs to be calculated if the above amount is greater.
            }

            else {
                this.adjustedAmountCalculation1(this.dictValues[i]);
            }
        }
        this.calculateTotalAmountToBePaid();
        this.amountAdjustmentCalculated = true;
        this.enableNewColumn = true;

        if (this.totalAmountToBePaidSting != "" && this.totalAmountToBePaidSting != undefined) {
            var splittotal = this.totalAmountToBePaidSting.split(',')[0];
            if (Number(splittotal) > 0) {
                this.enablePaymentButton = 1;
                this.ConfirmButtonStatus = 0;
            }
            else {
                this.enablePaymentButton = 0;
                this.ConfirmButtonStatus = 1;
            }
        }
    }


    calculateTotalAmountToBePaid() {
        for (var i = 0; i < this.paymentDetails.length; i++) {
            this.totalAmountToBePaid = this.totalAmountToBePaid + this.paymentDetails[i].AdjustedAmount;
            this.totalAmountToBePaidSting = this.totalAmountToBePaid.toFixed(2);
        }
    }

    adjustedAmountCalculation1(dictValues) {
        for (var p = 0; p < this.paymentDetails.length; p++) {
            if (this.paymentDetails[p].ServiceChecked) {
                if (this.paymentDetails[p].SponsorCode == dictValues.key) {
                    this.paymentDetails[p].AdjustedAmount = this.paymentDetails[p].Price;
                    this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                }
            }
            else {
                this.paymentDetails[p].AdjustedAmount = 0;
                this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
            }
        }
    }

    adjustedAmountCalculation(dictValues) {
        var adjust = 0;
        for (var p = 0; p < this.paymentDetails.length; p++) {
            if (this.paymentDetails[p].ServiceChecked) {
                if (this.paymentDetails[p].SponsorCode == dictValues.key) {
                    adjust = adjust + this.paymentDetails[p].Price;
                    if (dictValues.value == 0 && !this.copayAmountTotalRchd) {
                        this.paymentDetails[p].AdjustedAmount = this.paymentDetails[p].Price;
                        this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                        this.totalAdjustedAmount = this.totalAdjustedAmount + this.paymentDetails[p].AdjustedAmount;
                    }

                    else if (adjust >= dictValues.value && !this.copayAmountTotalRchd) {
                        this.copayAmountTotalRchd = true;
                        this.paymentDetails[p].AdjustedAmount = dictValues.value - this.totalAdjustedAmount;
                        this.paymentDetails[p].AdjustedAmount = this.paymentDetails[p].AdjustedAmount;
                        this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                    }

                    else if (adjust < dictValues.value && !this.copayAmountTotalRchd) {
                        this.paymentDetails[p].AdjustedAmount = this.paymentDetails[p].Price;
                        this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                        this.totalAdjustedAmount = this.totalAdjustedAmount + this.paymentDetails[p].AdjustedAmount;
                    }

                    else {
                        this.paymentDetails[p].AdjustedAmount = 0;
                        this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
                    }
                }
            }

            else {
                this.paymentDetails[p].AdjustedAmount = 0;
                this.paymentDetails[p].AdjustedAmountString = this.paymentDetails[p].AdjustedAmount.toFixed(2);
            }
        }
    }

    SendOtpToMobileNumber() {
        this.VerifyOtperrMsg = "";
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this._paymentService.SentOtp(this.otpModel, userData)
            .subscribe(
                p => {
                    this.otpModel = p;
                    this.HiddenMobileNumber = p.DummyMobileNumber;
                    this.IsOTPSent = true;
                    this.IsOtpVerifiedSucess = false;
                    this.IsSearchBtnClicked = false;
                    this.OtpNumber = "";
                }, err => {
                    console.log("Error while getting data...");
                });
    }

    StartCountdown(seconds) {
        let counter = seconds;
        const interval = setInterval(() => {
            this.TimeCounter = (counter--).toString();

            if (counter < 0) {
                this.IsOTPSent = false;
                clearInterval(interval);
            }
        }, 1000);
    }

    Clear() {
        this.appointmentPatientId = "";
        this.appointmentCivilId = "";
        this.IsOTPSent = false;
        this.IsVerifyOtpClicked = false;
        this.IsOtpVerifiedSucess = false;
        this.IsSearchBtnClicked = false;
        this.IsselectPatientSearch = false;
        this.CvilIdNoRed = false;
        this.IsMobileText = false;
        this.SelecterrMsg = "";
        this.IsDetailsDisplay = false;
        this.fileSearchRes = [];
        this.IsOtpVerifiedSucess = false;
        this.totalPatientPartAmountString = "";
        this.totalAmountToBePaidSting = "";
        this.totalGrossAmountString = "";
        this.totalAmountToBePaid = 0;
        this.totalAmountToBePaidSting = "";
        this.paymentDetails = [];
        this.enablePayProceedButton = false;
        this.guestBooking = false;
        this.VerifyOtperrMsg = "";
    }

    VerifyOtp(OtpNumber) {
        if (OtpNumber == "" || OtpNumber == null || OtpNumber == undefined) {
            this.IsSearchBtnClicked = false;
            this.IsOtpVerifiedSucess = false;
            this.IsVerifyOtpClicked = true;
            this.VerifyOtperrMsg = "Please enter OTP";

        }
        else {
            this.IsVerifyOtpClicked = false;
            this.VerifyOtperrMsg = "";
            this.IsOTPSent = false;
            this.IsSearchBtnClicked = false;
            this.otpModel.ENTEREDOTP = OtpNumber;
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            this._paymentService.VerifyOtp(this.otpModel, userData)
                .subscribe(
                    s => {
                        if (s.VERIFIED == "SUCCESS") {
                            this.IsOtpVerifiedSucess = true;

                        } else {
                            this.IsVerifyOtpClicked = true;
                            this.VerifyOtperrMsg = "Entered OTP is wrong!";
                            this.IsOTPSent = true;
                            this.IsSearchBtnClicked = false;
                            this.IsOtpVerifiedSucess = false;

                        }
                    });
        }
    }

    BackToLogin() {
        localStorage.setItem("PortalType", this.PortalType);
        localStorage.setItem("KioskORPortal", this.KioskORPortal);
        if (this.KioskORPortal == "KIOSK") {
            this.router.navigate(["/KioskLogin"]);
        }
        else {
            this.router.navigate(["/Login"]);
        }
    }
    FromonDateChanged(event: IMyDateModel) {
        this.paymentDetails = [];
        if (event != undefined) {
            var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
            this.activebutton = dt.getDay();
            this.FromDate = event.jsdate.toLocaleDateString();
        }
    }
    DateSearch() {
        this.IsDateError = false;
        this.DateErrorerrMsg = "";
        this.paymentDetails = [];
        var dateFrom = this.FromDate;
        var dateTo = this.ToDate;
        

        var d1 = dateFrom.split("/");
        var d2 = dateTo.split("/");
        

        var from = new Date(d1.toString());  // -1 because months are from 0 to 11
        var to = new Date(d2.toString());
        

        if (Date.parse(this.FromDate) > Date.parse(this.ToDate))
        {
            this.IsDateError = true;
            this.DateErrorerrMsg = "From Date should not be greater than To Date";
        }
        if (Date.parse(this.FromDate) <= Date.parse(this.ToDate)) {
            var a = [];
            for (var i = 0; i < this.dataSource.length; i++) {
                this.dataSource[i].AmountString = this.dataSource[i].Amount.toFixed(2);
                this.dataSource[i].priceString = this.dataSource[i].Price.toFixed(2);
                if (this.dataSource[i].Amount.toString().indexOf('.') <= 0) {
                    this.dataSource[i].AmountString = this.dataSource[i].Amount + ".00";
                }
                if (this.dataSource[i].Price.toString().indexOf('.') <= 0) {
                    this.dataSource[i].priceString = this.dataSource[i].Price + ".00";
                }
                var dateCheck = this.dataSource[i].RequestDate;
                var c = dateCheck.split("/");
                var check = new Date(c.toString());
               /* if (new Date(this.dataSource[i].RequestDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) >= new Date(this.FromDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
                    && new Date(this.dataSource[i].RequestDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) <= new Date(this.ToDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }))*/
                if (check >= from && check <= to) {
                    this.paymentDetails.push(this.dataSource[i]);
                }
                if (localStorage.getItem("BookingType") == "SLOT") {
                    if (a.indexOf(this.dataSource[i].SponsorCode) <= -1) {
                        a.push(this.dataSource[i].SponsorCode);
                        let kv: ServicePaykeyvaluepair = new ServicePaykeyvaluepair();
                        kv.key = this.dataSource[i].SponsorCode;
                        kv.value = this.dataSource[i].Co_payAmount;
                        this.dictValues.push(kv);
                    }
                }
            }
        }
    }

    ToDateonDateChanged(event: IMyDateModel) {
        if (event != undefined) {
            var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
            this.activebutton = dt.getDay();
            this.ToDate = event.jsdate.toLocaleDateString();
        }
    }

    makePdf() {
        const div = document.getElementById("Html2Pdf");
        const options = { height: div.clientHeight, width: div.clientWidth };
        html2canvas(div, options).then((canvas) => {
            //Initialize JSPDF
            const doc = new jspdf.jsPDF("p", "mm", "a4");
            //Converting canvas to Image
            const imgData = canvas.toDataURL("image/JPEG");
            //Add image Canvas to PDF
            doc.addImage(imgData, 'JPEG', 30, 30);
            //Name of pdf
            const fileName = "Receipt.pdf";
            // Make file
            doc.save(fileName);
        });
    }

    ModalClosePopup() {
        this.guestBooking = false;
        if (this.paytabsPaymentDetails.RedirectResult == "CANCELED")
            this.router.navigate(["/SearchServicePayment"]);
        else
        {     
            localStorage.setItem("KioskORPortal", this.KioskORPortal);
            if (this.KioskORPortal == "KIOSK") {
                this.router.navigate(["/KioskLogin"]);
            }
            else {
                this.router.navigate(["/Login"]);
            }
        }          
        this.guestBooking = false;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/SearchServicePayment/Component/SearchServicePayment.Component.ts